export default __webpack_public_path__ + "static/Stackery-6f6eccb7beda0806982813fdeae4501e.png";